import { FormControlLabel as MuiFormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Colors } from '../../../theme';

export const FormControlLabel = styled(MuiFormControlLabel)`
  .MuiCheckbox-root {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 8px;

    svg.MuiSvgIcon-root {
      // we scale the svg to have checkbox 16x16px
      transform: scale(0.8888);
    }
  }

  .MuiFormControlLabel-label {
    color: ${Colors.Gray[6]};
    font-size: 12px;
    letter-spacing: 0.8px;
    line-height: 20px;
  }
`;
